// extracted by mini-css-extract-plugin
module.exports = {"filtersMenu":"FiltersMenu_filtersMenu__LwL2z","category":"FiltersMenu_category__Xi9gB","introduction":"FiltersMenu_introduction__v32kQ"};